<template>
    <component :is="component" :utilityData="utilityData" v-if="component"/>
</template>

<script>
export default {
    name: "UtilityDetailLink",
    mixins: [],
    components: {},
    provide() {
        return {}
    },
    props: {
        detailLayout: '',
        utilityData: {
            default: () => {
            }
        },
    },
    data() {
        return {
            component: null,
        }
    },
    created() {
    },
    mounted() {
        this.writeFunc()
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.detailLayout) {
                return null
            }
            return () => import(`@/template/utility/detail/${this.detailLayout}`)
        },
    },
    methods: {
        writeFunc() {
            this.loader().then(() => {
                this.component = () => this.loader()
            })
                .catch(() => {
                    this.component = () => import('@/template/utility/detail/UtilityDetailDefaultLayout')
                })
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
